export default __webpack_public_path__ + "static/media/medium.bc816582.svg";